import React from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SAMPLE_STATUS_REF_KEY, DEFAULT_SAMPLE_STATUS_COLOR } from '../../../constants/sample-status.constants';

export default function CardDrag({
  item,
  index,
  handleChanged,
  renderTooltipActiveInactive,
  activeInactiveClicked,
  renderTooltipDelete,
  handleDelete,
  handleSampleStatus,
  isUniqueId,
  masterAddEditAccess,
  masterDeleteAccess,
  statusMasterTypes,
}) {
  const { t } = useTranslation('common');
  const title = 'sampleStatusMaster';
  const rountShape = ' rount-shape ';
  /*
   * The seeded default status (refKey '-') is the one every new sample is created with, so it is
   * fully locked: name read-only, colour fixed to amber with no picker, and no activate/delete
   * controls. Every other status — including unsaved rows, which carry no refKey — is editable.
   */
  const isDefaultStatus = item?.refKey === DEFAULT_SAMPLE_STATUS_REF_KEY;

  return index === 0 && statusMasterTypes?.value === 'sample' ? (
    <li key={index}>
      <div className="input-container">
        <div className="d-flex">
          <input
            key={index}
            name="sampleStatusMaster"
            value={item?.name ? item?.name : ''}
            autoFocus={!item?._id}
            placeholder={statusMasterTypes?.value === 'sample' ? t('CARD_DRAG_SAMPLE.ENTER_SAMPLE_STATUS') : t('CARD_DRAG_SAMPLE.ENTER_SUPPLIER_STATUS_MASTER')}
            type="text"
            onChange={(e) => handleChanged(e, index)}
            disabled={!masterAddEditAccess}
          />
        </div>
      </div>
      {masterAddEditAccess && (
        <div className="input-action">
          <div className="status-color-container sample-status-color-container">
            <span className={item?.statusColor ? item?.statusColor + rountShape : rountShape} />
          </div>
        </div>
      )}
    </li>
  ) : (
    <div className="list-container">
      <li key={index}>
        <div className="input-container">
          <div className="d-flex">
            <input
              key={index}
              name="sampleStatusMaster"
              value={item?.name ? item?.name : ''}
              autoFocus={!item?._id}
              placeholder={
                statusMasterTypes?.value === 'sample' ? t('CARD_DRAG_SAMPLE.ENTER_SAMPLE_STATUS') : t('CARD_DRAG_SAMPLE.ENTER_SUPPLIER_STATUS_MASTER')
              }
              type="text"
              onChange={(e) => handleChanged(e, index)}
              disabled={!masterAddEditAccess || isDefaultStatus}
            />
          </div>

          {isUniqueId && isUniqueId.length !== 0 && isUniqueId.includes(index) && (
            <label className="text-danger m-0 p-1">{t('CARD_DRAG_SAMPLE.ENTRY_ALREADY_EXIST')}</label>
          )}

          {item.isEmpty && (item.name === null || item.name === '') && (
            <label className="text-danger m-0 p-1">
              {statusMasterTypes?.value === 'sample' ? t('CARD_DRAG_SAMPLE.SAMPLE_STATUS_REQUIRED') : t('CARD_DRAG_SAMPLE.SUPPLIER_STATUS_REQUIRED')}
            </label>
          )}

          {item.isNew && item.name && item.name.length && !item.name.trim().length && (
            <label className="text-danger m-0 p-1">
              {statusMasterTypes?.value === 'sample' ? t('CARD_DRAG_SAMPLE.SAMPLE_STATUS_ENTRY_INVALID') : t('CARD_DRAG_SAMPLE.ENTER_SUPPLIER_STATUS_MASTER')}
            </label>
          )}
        </div>
        <div className="input-action">
          {item?._id !== '' && masterAddEditAccess && (
            <>
              <div className="status-color-container sample-status-color-container">
                <span className={isDefaultStatus ? DEFAULT_SAMPLE_STATUS_COLOR + rountShape : (item?.statusColor ? item?.statusColor + rountShape : rountShape)} />
                {!isDefaultStatus && (
                  <div className="color-group">
                    <span onClick={() => handleSampleStatus(index, 'red')} className="red rount-shape" />
                    <span onClick={() => handleSampleStatus(index, 'amber')} className="amber rount-shape" />
                    <span onClick={() => handleSampleStatus(index, 'green')} className="green rount-shape" />
                  </div>
                )}
              </div>

              {!isDefaultStatus && (
                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                  <button
                    onClick={() => activeInactiveClicked(item?._id, title)}
                    id={item?._id}
                    type="button"
                    aria-label={item?.isActive ? 'Active' : 'Inactive'}
                  >
                    <span className={item?.isActive ? 'icon-active' : 'icon-inactive'} />
                  </button>
                </OverlayTrigger>
              )}
            </>
          )}
          {masterDeleteAccess && !isDefaultStatus && (
            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
              <button
                onClick={() => {
                  handleDelete(item?._id ? item?._id : index, title);
                }}
                type="button"
                aria-label="Delete"
              >
                <span className="icon-delete mt-3 f-20" />
              </button>
            </OverlayTrigger>
          )}
        </div>
      </li>
    </div>
  );
}
